/**
 * syllabusApi.js
 * --------------
 * Production API client for Education > Lectures > Syllabus submodule.
 * Connects directly to FastAPI 4-layer backend with zero mock data.
 */
import api from '../../../../api/client'

/**
 * Fetch paginated syllabus curriculum list.
 * @param {Object} params - Query filters (academicYear, courseId, subjectId, schoolId, chapterNo, searchText, orderBy, page, pageSize)
 */
export async function fetchSyllabusList(params = {}) {
  const { data } = await api.get('/lectures/syllabus', { params })
  return data
}

/**
 * Retrieve single syllabus chapter detail by ID.
 * @param {number|string} id - Syllabus ID
 */
export async function getSyllabusById(id) {
  const { data } = await api.get(`/lectures/syllabus/${id}`)
  return data
}

/**
 * Create or update syllabus chapter.
 * @param {Object} payload - Syllabus form data
 */
export async function saveSyllabusItem(payload) {
  if (payload.id) {
    const { data } = await api.put(`/lectures/syllabus/${payload.id}`, payload)
    return data
  }
  const { data } = await api.post('/lectures/syllabus', payload)
  return data
}

/**
 * Soft delete syllabus chapter.
 * @param {number|string} id - Syllabus ID
 */
export async function deleteSyllabusItem(id) {
  const { data } = await api.delete(`/lectures/syllabus/${id}`)
  return data
}

/**
 * Download sample Excel template for Syllabus bulk upload.
 */
export async function downloadSyllabusTemplate() {
  const response = await api.get('/lectures/syllabus/template', {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'Import_Syllabus_Template.xlsx'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

/**
 * Bulk upload Excel spreadsheet for Syllabus.
 * @param {File} file - Excel spreadsheet file (.xlsx / .xls)
 */
export async function uploadSyllabusExcel(file) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post('/lectures/syllabus/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
